import { getDirectusClient } from '../lib/directus';
import { readItems } from '@directus/sdk';
const directus = getDirectusClient();
export const getOrdenesByFactura = async (
  numero_factura,
  page = 1,
  limit = -1
) => {
  try {
    const response = await directus.request(
      readItems('ordenes_decompra', {
        fields: [
          'id',
          'numero_factura',
          'date_created',
          'bodegas.bodegas_id.nombre',
          'user_created.first_name',
          'estado.nombre',
          'productos.grupo',
          'productos.*',
          'proveedor.documento',
          'proveedor.nombre',
          'productos.producto_detalle.nombre',
           "comprobante"
        ],
        limit: -1,
        sort: '-date_created',
        filter: {
          _and: [
            {
              numero_factura: {
                _contains: numero_factura,
              },
            },
          ],
        },
        page: page,
        limit: limit,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getOrdenesCount = async (userRoleID, userBodega) => {
  try {
    const response = await directus.request(
      readItems('ordenes_decompra', {
        fields: [
          'id',
          'numero_factura',
          'date_created',
          'bodegas.bodegas_id.nombre',
          'user_created.first_name',
          'estado.nombre',
          'productos.grupo',
          'productos.*',
          'proveedor.documento',
          'proveedor.nombre',
          'productos.producto_detalle.nombre',
           "comprobante"
        ],
        limit: -1,
        sort: '-date_created',
        filter: {
          ...(userRoleID !== 'adminapp' && userRoleID !== 'Administrator'
            ? {
                bodegas: {
                  bodegas_id: {
                    id: { _eq: userBodega },
                  },
                },
              }
            : {}),
        },
        aggregate: {
          countDistinct: ['id'],
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getOrdenes = async (userRoleID, userBodega) => {
  try {
    const response = await directus.request(
      readItems('ordenes_decompra', {
        fields: [
          'id',
          'numero_factura',
          'date_created',
          'bodegas.bodegas_id.nombre',
          'user_created.first_name',
          'estado.nombre',
          'productos.grupo',
          'productos.*',
          'proveedor.documento',
          'proveedor.nombre',
          'productos.producto_detalle.nombre',
          "comprobante",
          "impuesto_isc",
          "productos.producto_detalle.grupo.impuestos.impuestos_id.nombre",
          "productos.producto_detalle.grupo.impuestos.impuestos_id.porcentaje",
          "productos.producto_detalle.grupo.impuestos.impuestos_id.id"
        ],
        limit: -1,
        sort: '-date_created',
        filter: {
          ...(userRoleID !== 'adminapp' && userRoleID !== 'Administrator'
            ? {
                bodegas: {
                  bodegas_id: {
                    id: { _eq: userBodega },
                  },
                },
              }
            : {}),
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
